import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReconcilliationReportComponent } from './reconcilliation-report.component';

const routes: Routes = [{
  path:'',
  component: ReconcilliationReportComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReconcilliationReportRoutingModule { }
